import { Card, CardContent, CardProps } from '@material-ui/core';
import PostAddOutlinedIcon from '@material-ui/icons/PostAddOutlined';
import { DocumentCreateOrUploadForm } from 'documents/DocumentCreateOrUploadForm';
import { CardTitleTypography } from 'framework/components/CardTitleTypography';
import { DividerWithMargin } from 'framework/components/DividerWithMargin';
import { TextLinkButton } from 'framework/components/buttons/TextLinkButton';
import { useApiEffect } from 'framework/hooks/useApiEffect';
import { useLazyEffect } from 'framework/hooks/useLazyEffect';
import { isLast } from 'framework/utils/array/isLast';
import { IDocumentsByContextAndIdParams, ILoan, LinkViewContextType, TemplateType, documentsQuery_byIdAndContextNotDeleted } from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';
import React, { useContext, useMemo } from 'react';
import { useDialogsContext } from 'shared/dialogs/useDialogsContext';
import { IReloadTriggerProps } from 'shared/layout/IReloadTriggerProps';
import { RecordContext } from 'shared/records/RecordContext';
import { DocumentListItemXDefault } from '../../../../../documents/DocumentListItemXDefault';

const LoanLinkViewContextType: LinkViewContextType = 'Loan';

interface IProps extends CardProps, IReloadTriggerProps {
	item: ILoan;
	reload: VoidFunction;
}

export const LoanDetailDocumentsCard = ({ item, reload, reloadTrigger, ...rest }: IProps) => {
	const strings = useLocalization();
	const params = useMemo<IDocumentsByContextAndIdParams>(() => ({ linkViewContextId: item.id, linkViewContextType: LoanLinkViewContextType }), [item]);
	const [documents, reloadDocuments] = useApiEffect(documentsQuery_byIdAndContextNotDeleted, params);
	const { templateTypeRecord } = useContext(RecordContext);
	const { open, confirm, cancel } = useDialogsContext(reload);

	useLazyEffect(() => {
		reloadDocuments();
	}, [reloadTrigger]);

	const onNew = (type: TemplateType) => {
		open(
			<DocumentCreateOrUploadForm
				title={templateTypeRecord[type]}
				templatePredefinedType={type}
				context={LoanLinkViewContextType}
				contextId={item.id}
				confirm={confirm}
				cancel={cancel}
			/>
		);
	};

	if (documents === undefined) {
		return <></>;
	}

	return (
		<Card {...rest}>
			<CardContent>
				<CardTitleTypography
					title={strings.documents}
					style={{ marginBottom: 8 }}
				/>
				<TextLinkButton
					startIcon={<PostAddOutlinedIcon />}
					onClick={() => onNew(item.isSubProcess ? 'RfiaLoanSlip' : 'LoanSlip')}
					color='primary'>
					{strings.loanSlip}
				</TextLinkButton>
				<DividerWithMargin />
				{documents.map(t => (
					<DocumentListItemXDefault
						key={t.id}
						item={t}
						reload={reloadDocuments}
						withoutBorder={isLast(t, documents)}
					/>
				))}
				{documents.length === 0 && <em>{strings.noDocumentsAddedYet}</em>}
			</CardContent>
		</Card>
	);
};
